import { useState } from 'react';
import { cn } from '@/lib/utils';
import { ActionsSidebarToggle } from './ActionsSidebarToggle';

export function PricelistSidebarShell({
  heading,
  children,
}: {
  heading: React.ReactNode;
  children: React.ReactNode;
}) {
  const [open, setOpen] = useState(true);

  return (
    <div
      className={cn(
        'flex h-full shrink-0 flex-col border-l',
        open ? 'w-72 overflow-hidden bg-card' : 'bg-muted/40',
      )}
    >
      <div
        className={cn(
          'flex h-11 shrink-0 items-center px-2',
          open ? 'justify-between border-b bg-muted/40' : 'justify-end',
        )}
      >
        {open ? (
          <span className="pl-1 text-sm font-medium text-foreground">
            {heading}
          </span>
        ) : undefined}
        <ActionsSidebarToggle
          open={open}
          onToggle={() => setOpen((prev) => !prev)}
        />
      </div>

      {open ? (
        <div className="flex-1 overflow-y-auto p-4">{children}</div>
      ) : undefined}
    </div>
  );
}
